import {
  POST_MEDIUM_LOGIN,
  POST_MEDIUM_LOGOUT,
  SET_MEDIUM_DATA,
} from "../../constants/type";
import Api from "../../utils/api";
import { EndPoints } from "../../constants/endpoints";

export const login = (data) => {
  return (dispatch) => {
    return {
      type: POST_MEDIUM_LOGIN,
      payload: () => {
        return Api.post(EndPoints.medium("auth"), data).then((response) => {
          if (response.status < 300) {
            dispatch(setData(response.data));
          }
          return response;
        });
      },
    };
  };
};

export const logout = () => {
  return (dispatch) => {
    return {
      type: POST_MEDIUM_LOGOUT,
      payload: () => {
        return Api.delete(EndPoints.medium("auth"));
      },
    };
  };
};

export const setData = (data) => {
  return {
    type: SET_MEDIUM_DATA,
    data: data,
  };
};
